import React from 'react'
import styled from 'styled-components'
import {Upload} from 'wix-style-react/dist/src/Icons'

const DragNDropDisclimer = styled.div`
  background: #3899EC;
  border-radius: 40px;
  padding: 16px 34px;
  color: white;
  line-height: 20px;
`
const UploadIcon = styled.span`
  position: relative;
  right: 8px;
  top: 2.5px;
`

const UploadDisclimer = () => {
  return (
    <DragNDropDisclimer>
      <UploadIcon><Upload size='0.9em' /></UploadIcon>
      <span>Drop to upload files to Whimm</span>
    </DragNDropDisclimer>
  )
}

export default UploadDisclimer



// WEBPACK FOOTER //
// ./src/components/editor/assetsManager/UploadDisclimer.js